import { CommonModule } from '@angular/common';
import {
    ChangeDetectionStrategy,
    Component,
    EventEmitter,
    HostListener,
    Input,
    OnChanges,
    OnInit,
    Output,
} from '@angular/core';

import { ProductLine } from '@bytel/checkout';

import { PriceComponent } from '@base/trilogy/price/price.component';

import { IFormStatus } from '@interfaces/checkout.interface';

@Component({
    selector: 'checkout-sticky',
    standalone: true,
    imports: [CommonModule, PriceComponent],
    templateUrl: './sticky.component.html',
    styleUrl: 'sticky.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class StickyComponent implements OnInit, OnChanges {
    @Input() fundingPrice: number;
    @Input() showDaily: boolean = false;
    @Input() showMonthly: boolean = false;
    @Input() edpTicketLine: ProductLine = null;
    @Input() public prices: {
        DAILY: number;
        MONTHLY: number;
    };
    @Input() public noButtons: boolean = false;
    @Input() public formData: IFormStatus;
    @Output() validateEvent = new EventEmitter<void>();

    public showSticky: boolean = false;
    public showFunding: boolean = false;

    @HostListener('document:scroll')
    handleScroll(): void {
        const windowTop = document.documentElement.scrollTop;
        const top = document.getElementById('checkout').offsetTop;
        const ticket = document.getElementById('checkout-ticket').offsetTop;
        this.showSticky = windowTop > top && windowTop < ticket;
    }

    ngOnInit(): void {
        this.refresh();
    }

    ngOnChanges(): void {
        this.refresh();
    }

    goToNextStep(): void {
        this.validateEvent.emit();
    }

    private refresh(): void {
        this.showFunding = !!this.fundingPrice;
    }
}
